import angular from 'angular'

class redInkConfirmFormDetailCtrl {
    constructor($scope, httpRequest, globalFn, logger, sweetalert, items1, $uibModalInstance, $stateParams) {
        $scope.title = items1.title
        let confirmId  = items1.item?items1.item.confirmId:items1.confirmId
        httpRequest.post_getRedConfirmBody({confirmId:confirmId}).then((res) => {
            $scope.invoice = res.data.value
            totalCalculation($scope.invoice.ovatTax4RedConfirmDetails)
        })
        $scope.dictData = {}
        const types = ['red_confirm_work_status','red_confirm_status','red_confirm_open_status','red_confirm_red_reason','vat_usage_code','excise_usage_code','entry_status']
        httpRequest.get_dictByTypeArr(types).then((res) => {
            $scope.dictData = res.data.value
        })
        $scope.filterUkeyName = function filterUkeyName(id) {
            const userInfo = JSON.parse(localStorage.getItem('user_info'))
            if (id === null) {
                return id
            }
            if (userInfo.sysUkeyList === null) {
                return id
            }
            const fliterUkeyNameArr = userInfo.sysUkeyList.filter((item) => item.ukeyId === id)
            if (fliterUkeyNameArr.length > 0) {
                return fliterUkeyNameArr[0].ukeyName
            }
            return id
        }

        // 更新 合计 金额 税额
        function totalCalculation(billList) {
            $scope.totalAmount = 0
            $scope.totalTaxAmount = 0
            $scope.totalAdValoremTotal = 0
            angular.forEach(billList, (item, index) => {
                $scope.totalAmount = globalFn.Add($scope.totalAmount, item.amount)
                $scope.totalTaxAmount = globalFn.Add($scope.totalTaxAmount, item.taxAmount)
                $scope.totalAdValoremTotal = globalFn.Add($scope.totalAmount, $scope.totalTaxAmount)
            })
            $scope.chineseAmtTotal = globalFn.digitUppercase($scope.totalAdValoremTotal)
        }
        // 关闭
        $scope.cancel = function cancel() {
            $uibModalInstance.dismiss('cancel')
        }
    }
}

redInkConfirmFormDetailCtrl.$inject = ['$scope', 'httpRequest', 'globalFn', 'logger', 'sweetalert', 'items1', '$uibModalInstance', '$stateParams']
export default redInkConfirmFormDetailCtrl



// WEBPACK FOOTER //
// ./src/app/outputManage/fullElectricInvoice/redInkConfirmForm/detail.js